import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import InputSearch from 'ui/atoms/InputSearch/InputSearch';
import Loading from 'ui/atoms/Loading/Loading';
import SelectCustomizable, { utilsSelectCustomizable } from 'ui/atoms/SelectCustomizable/SelectCustomizable';
import PropTypes from 'prop-types';
import UnitList from 'core/modules/components/lists/units/UnitList/UnitList';
import BookSelect from 'core/modules/components/selects/BookSelect/BookSelect';
import React from 'react';

import useDialogUnit from './useDialogAddUnit';

const DialogAddUnit = ({ courseUnits, open, onClose, onCopied, times, activeTime }) => {
  const {
    t,
    loading,
    units,
    selectedUnits,
    amountUnits,
    disableUnits,
    disciplines,
    levels,
    filters,
    programs,
    hasMore,
    loadMoreUnits,
    onCloseDialog,
    onChangeSearch,
    onSelectDiscipline,
    onSelectLevel,
    onSelectProgram,
    onChangeUnitSelected,
    onAddSelectedUnits,
    onChangeTimeSelected,
    optionsTimes,
  } = useDialogUnit({ open, courseUnits, onClose, onCopied, times, activeTime });

  const ALL_LEVELS = { label: t('common:All education levels'), value: '' };
  const PARSE_LEVELS = utilsSelectCustomizable.getOptionsProperties(levels, 'name', 'guid');
  const ALL_DICISPLINES = { label: t('common:All subjects'), value: '' };
  const PARSE_DISCIPLINES = utilsSelectCustomizable.getOptionsProperties(disciplines, 'name', 'guid');
  const ALL_PROGRAMS = { label: <BookSelect name={t('common:All books')} />, value: '' };

  function setResultsLengthText() {
    if (filters.search) {
      if (amountUnits > 0) {
        return t('lesson:Number of results', { count: amountUnits }) + ' ' + '"' + filters.search + '"';
      } else {
        return t('lesson:No result for') + ' ' + '"' + filters.search + '"';
      }
    } else {
      return t('lesson:Number of units founded', { count: amountUnits });
    }
  }

  return (
    <Dialog
      title={t('course:Add unit')}
      isOpen={open}
      className={'dialog-add-unit'}
      size="xxl"
      onClose={onCloseDialog}
      onCancel={onCloseDialog}
      buttonTextSuccess={selectedUnits.length === 0 ? t('content:Insert file') : t('lesson:Add Units', { count: selectedUnits.length })}
      onSuccess={onAddSelectedUnits}
      isDisabledSuccess={selectedUnits.length === 0}
      customFooterLeft={
        <div className={'dialog-add-unit__select-quarter'}>
          {times?.length > 1 && (
            <div className="dialog-add-unit__select">
              <SelectCustomizable
                label={t('calendar:Calendar')}
                options={optionsTimes}
                defaultValue={activeTime && activeTime !== 'all' ? optionsTimes.filter((time) => time.value === activeTime) : optionsTimes[0] || 1}
                placeholder={
                  <div className="dialog-add-unit__select-time">
                    <Icon name="calendar" size="md" />
                    <span className="dialog-add-unit__select-time-text"> {`${t('course:Select quarter')}`}</span>
                  </div>
                }
                onChange={onChangeTimeSelected}
              />
            </div>
          )}
        </div>
      }
    >
      <div className="dialog-add-unit__container">
        {loading && <Loading />}
        <div className="dialog-add-unit__filters">
          <div className="dialog-add-unit__search">
            <InputSearch placeholder={t('placeholder:Search')} onChange={onChangeSearch} value={filters.search} iconPosition="left" />
          </div>
          <div className="dialog-add-unit__filter-level">
            <SelectCustomizable
              options={[ALL_LEVELS, ...PARSE_LEVELS]}
              placeholder={t('common:Education level')}
              onChange={onSelectLevel}
              defaultValue={ALL_LEVELS}
            />
          </div>
          <div className="dialog-add-unit__filter-discipline">
            <SelectCustomizable
              options={[ALL_DICISPLINES, ...PARSE_DISCIPLINES]}
              placeholder={t('common:Subject')}
              onChange={onSelectDiscipline}
              defaultValue={ALL_DICISPLINES}
            />
          </div>
          <div className="dialog-add-unit__filter-book">
            <SelectCustomizable
              options={[
                ALL_PROGRAMS,
                ...programs.map((program) => {
                  return { label: <BookSelect cover={program.picture} name={program.name} />, value: program.guid };
                }),
              ]}
              placeholder={t('common:Books')}
              onChange={onSelectProgram}
              defaultValue={ALL_PROGRAMS}
            />
          </div>
        </div>
        <div className="dialog-add-unit__number-results">{setResultsLengthText()}</div>
        <div id="dialog-add-unit__list">
          <UnitList
            t={t}
            units={units}
            legend={t('course:Add unit')}
            isLegendHidden
            selectedUnits={selectedUnits}
            disableUnits={disableUnits}
            hasMore={hasMore}
            onChangeSelected={onChangeUnitSelected}
            loadMore={loadMoreUnits}
          />
        </div>
      </div>
    </Dialog>
  );
};

DialogAddUnit.propTypes = {
  activeTime: PropTypes.object,
  courseUnits: PropTypes.array,
  onClose: PropTypes.func,
  onCopied: PropTypes.func,
  open: PropTypes.bool,
  times: PropTypes.array,
};

DialogAddUnit.defaultProps = {
  courseUnits: [],
  onClose: function () {},
  open: false,
};

export default DialogAddUnit;
